import { useParams } from 'react-router-dom';
import { useGetPageById } from '@tinct/core-api';
import { TrackedEventsSection } from '../../shared';

export function VariantTrackedEventsTab() {
  const { variantId = '' } = useParams<{ id: string; variantId: string }>();

  const { data: page } = useGetPageById({
    id: variantId,
    fields: {
      id: null,
      statistics: {
        fields: {
          trackedEvents: {
            fields: {
              blockId: null,
              eventName: null,
              count: null,
              ratio: null,
              lastSeenAt: null,
            },
          },
        },
      },
    },
  });

  return (
    <TrackedEventsSection
      trackedEvents={page?.statistics?.trackedEvents}
      isReady={page !== undefined}
    />
  );
}
